/**
 * FEAT-113 — which analytics tools may load, decided from The CMO Lab's
 * consent cookie. Pure, so it is testable without a browser.
 *
 * The nagareru.ai landing page stores the visitor's answer in
 * `cmolab_consent` on `.nagareru.ai`; app.nagareru.ai reads the same cookie.
 * No answer, or "No thanks", loads nothing (measurement-taxonomy.md §9 in the
 * thecmolab-site repo).
 */

export type Consent = "granted" | "denied";

const DEFAULT_POSTHOG_HOST = "https://eu.i.posthog.com";

export function readConsent(cookie: string): Consent | null {
  const m = cookie.match(/(?:^|; )cmolab_consent=(granted|denied)(?:;|$)/);
  return m ? (m[1] as Consent) : null;
}

export interface AnalyticsEnv {
  gaId?: string;
  posthogKey?: string;
  posthogHost?: string;
}

export interface AnalyticsConfig {
  ga: string | null;
  posthog: { key: string; host: string } | null;
}

export function analyticsConfig(consent: Consent | null, env: AnalyticsEnv): AnalyticsConfig {
  if (consent !== "granted") return { ga: null, posthog: null };
  return {
    ga: env.gaId || null,
    posthog: env.posthogKey
      ? { key: env.posthogKey, host: env.posthogHost || DEFAULT_POSTHOG_HOST }
      : null,
  };
}
